import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { IoIosArrowDown } from "react-icons/io";
import { RiSettings3Fill } from "react-icons/ri";
const ListHeaderNew = () => {
  const [tab, setTab] = useState(0);
  const Svg = () => {
    return (
      <svg
      style={{marginRight:"6px"}}
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="rgb(81,145,189)"
        class="bi bi-sliders2"
        viewBox="0 0 16 16"
      >
        <path
          fill-rule="evenodd"
          d="M10.5 1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4H1.5a.5.5 0 0 1 0-1H10V1.5a.5.5 0 0 1 .5-.5M12 3.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m-6.5 2A.5.5 0 0 1 6 6v1.5h8.5a.5.5 0 0 1 0 1H6V10a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5M1 8a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 1 8m9.5 2a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V13H1.5a.5.5 0 0 1 0-1H10v-1.5a.5.5 0 0 1 .5-.5m1.5 2.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5"
        />
      </svg>
    );
  };
  return (
    <div className="mb-2 d-flex align-items-center">
      <Button
        onClick={() => {
          tab == 1 ? setTab(0) : setTab(1);
        }}
        className="theme_light_btn btn btn-primary d-flex align-items-center position-relative"
        style={{ marginRight: "5px" }}
      >
        {/* <RiSettings3Fill
          style={{ color: "rgb(81,145,189)", marginRight: "5px" }}
          size={15}
        />{" "} */}
        <Svg/>
        Odds Differential Filter (%){" "}
        <IoIosArrowDown style={{ marginLeft: "5px" }} />
        {tab == 1 && (
          <div id="userFilterDialog" class="filter-wrap" style={{ left: "0%" }}>
            <div class="filter_title">
              <h3>Odds Differential Filter</h3>
              <a
                id="userFilterCloseBtn"
                class="close_pop"
                href="javascript:void(0);"
              ></a>
            </div>

            <div class="filter_content-wrap">
              <div class="">
                <p
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    paddingBottom: "2px",
                  }}
                >
                  <strong
                    style={{
                      marginRight: "10px",
                      fontSize: "11px",
                      fontWeight: "500",
                    }}
                  >
                    Back {">="}
                  </strong>
                  <input
                    style={{ height: "23px" }}
                    type="text"
                    className="input-new-textarea"
                    id="userId"
                    size="20"
                    maxlength="20"
                    placeholder=""
                  />{" "}
                  %
                </p>
                <p
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    paddingBottom: "2px",
                  }}
                >
                  <strong
                    style={{
                      marginRight: "10px",
                      fontSize: "11px",
                      fontWeight: "500",
                    }}
                  >
                    Back {"<="}
                  </strong>
                  <input
                    style={{ height: "23px" }}
                    type="text"
                    className="input-new-textarea"
                    id="userId"
                    size="20"
                    maxlength="20"
                    placeholder=""
                  />{" "}
                  %
                </p>{" "}
                <p
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    paddingBottom: "2px",
                  }}
                >
                  <strong
                    style={{
                      marginRight: "10px",
                      fontSize: "11px",
                      fontWeight: "500",
                    }}
                  >
                    Lay {">="}
                  </strong>
                  <input
                    style={{ height: "23px" }}
                    type="text"
                    className="input-new-textarea"
                    id="userId"
                    size="20"
                    maxlength="20"
                    placeholder=""
                  />{" "}
                  %
                </p>{" "}
                <p
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    paddingBottom: "2px",
                  }}
                >
                  <strong
                    style={{
                      marginRight: "10px",
                      fontSize: "11px",
                      fontWeight: "500",
                    }}
                  >
                    Lay {"<="}
                  </strong>
                  <input
                    style={{ height: "23px" }}
                    type="text"
                    className="input-new-textarea"
                    id="userId"
                    size="20"
                    maxlength="20"
                    placeholder=""
                  />{" "}
                  %
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-end align-items-center p-2">
              <Button
                className="theme_dark_btn"
                style={{ marginRight: "10px" }}
              >
                Refresh
              </Button>
            </div>
          </div>
        )}
      </Button>
      <Button
        onClick={() => {
          tab == 2 ? setTab(0) : setTab(2);
        }}
        className="theme_light_btn btn btn-primary d-flex align-items-center position-relative"
        style={{ marginRight: "5px" }}
      >
        {/* <RiSettings3Fill
          style={{ color: "rgb(81,145,189)", marginRight: "5px" }}
          size={15}
        />{" "} */}
         <Svg/>
        User Filter
        <IoIosArrowDown style={{ marginLeft: "5px" }} />
        {tab == 2 && (
          <div id="userFilterDialog" class="filter-wrap" style={{ left: "0%" }}>
            <div class="filter_title">
              <h3>User Filter</h3>
              <a
                id="userFilterCloseBtn"
                class="close_pop"
                href="javascript:void(0);"
              ></a>
            </div>

            <div class="filter_content-wrap">
              <div class="">
                {/* <p class="filter_selection-switch">
                <a
                  href="javascript:void(0);"
                  id="userFilterFlag"
                  class="toggle_off"
                >
                 
                </a>
              </p> */}
                <p
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  <strong style={{ marginRight: "10px" }}>User Level</strong>
                  <select
                    style={{ height: "25px" }}
                    id="userType"
                    name="userType"
                  >
                    <option value="3">Master Agent</option>

                    <option value="0">Player</option>
                  </select>
                </p>

                <p
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  <strong style={{ marginRight: "10px" }}>User ID</strong>
                  <input
                    style={{ height: "23px" }}
                    type="text"
                    id="userId"
                    size="20"
                    maxlength="20"
                    placeholder=""
                  />
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-end align-items-center p-2">
              <Button
                className="theme_dark_btn"
                style={{ marginRight: "10px" }}
              >
                Refresh
              </Button>
            </div>
          </div>
        )}
      </Button>
      <Button
        onClick={() => {
          tab == 3 ? setTab(0) : setTab(3);
        }}
        className="theme_light_btn btn btn-primary d-flex align-items-center position-relative"
      >
        {/* <RiSettings3Fill
          style={{ color: "rgb(81,145,189)", marginRight: "5px" }}
          size={15}
        /> */}
         <Svg/>
        IP/ISP Filter
        <IoIosArrowDown style={{ marginLeft: "5px" }} />
        {tab == 3 && (
          <div id="userFilterDialog" class="filter-wrap" style={{ left: "0%" }}>
            <div class="filter_title">
              <h3>IP/ISP Filter</h3>
              <a
                id="userFilterCloseBtn"
                class="close_pop"
                href="javascript:void(0);"
              ></a>
            </div>

            <div class="filter_content-wrap">
              <div class="">
                {/* <p class="filter_selection-switch">
                <a
                  href="javascript:void(0);"
                  id="userFilterFlag"
                  class="toggle_off"
                >
                 
                </a>
              </p> */}
                <p
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  <strong style={{ marginRight: "10px" }}>IP</strong>
                  <input
                    style={{ height: "23px" }}
                    type="text"
                    id="userId"
                    size="20"
                    maxlength="20"
                    placeholder=""
                  />
                </p>
                <p
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  <strong style={{ marginRight: "10px" }}>ISP</strong>
                  <input
                    style={{ height: "23px" }}
                    type="text"
                    id="userId"
                    size="20"
                    maxlength="20"
                    placeholder=""
                  />
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-end align-items-center p-2">
              <Button
                className="theme_dark_btn"
                style={{ marginRight: "10px" }}
              >
                Refresh
              </Button>
            </div>
          </div>
        )}
      </Button>
    </div>
  );
};

export default ListHeaderNew;
